<template>
  <div class="col-12">
    <div class="text-center" v-if="loadingItem">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-row v-if="!loadingItem" class="p-2 bg-white m-0">
      <b-col v-if="permissions.includes('admin')" cols="12" md="12">
        <requiredComponent
          slot="label"
          :label="$lang.explanation"
          :rules="$v.description.$params"
        />
        <editor
          dir="rtl"
          v-model="description"
          resource="interview_k_help"
          resourceId="0"
        >
        </editor>
        <b-form-invalid-feedback id="name-feedback">
          {{
            $lang.error_required | replace($lang.explanation)
          }}</b-form-invalid-feedback
        >
      </b-col>
      <b-col v-else cols="12">
        <p v-html="description"></p>
      </b-col>

      <b-col cols="12" md="12" class="float-right">
        <div slot="footer" class="form-group form-btn">
          <b-button
            @click="save"
            type="submit"
            v-if="permissions.includes('admin') || permissions.includes('edit')"
            size="md"
            variant="success"
          >
            <i class="fa fa-check"></i>
            {{ $lang.submitButton }}
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancel"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import editor from "@/components/ckeditor/editor";

export default {
  inject: ["interviewKhelpRepository"],
  validations: {
    description: {},
  },
  components: {
    editor,
  },
  props: {},
  data() {
    return {
      description: null,
      permissions: [],
      loadingItem: false,
    };
  },
  methods: {
    async getHelp() {
      try {
        this.loadingItem = true;
        const response = await this.interviewKhelpRepository.list();
        this.description = response.data.data.description;
        this.permissions = response.data.permissions;
        this.resource = response.data.data.resource;
        this.loadingItem = false;
      } catch (error) {
        this.$generateError(error);
      }
    },
    async save() {
      try {
        let paylaod = {
          description: this.description,
        };
        let resource = this.resource;
        const response = await this.interviewKhelpRepository.edit(
          resource,
          paylaod
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
  created() {
    this.getHelp();
  },
};
</script>

